import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  addScannedProduct: (body, queryParams) => {
    return httpApi.postDataViaApi({
      url: api.rewards.addScannedProduct,
      body,
      queryParams
    })
  },

  scannedProductList: queryParams => {
    return httpApi.getDataViaApi({
      url: api.rewards.scannedProductList,
      queryParams
    })
  },

  downloadProducts: queryParams => {
    return httpApi.getDataViaApi({
      url: api.rewards.downloadProducts,
      queryParams
    })
  },

  uploadProducts: (body) => {
    return httpApi.uploadFileViaApi({
      url: api.rewards.uploadProducts,
      body
    })
  },

  getEngagementInfo: (body) => {
    return httpApi.postDataViaApi({
      url: api.rewards.getEngagementInfo,
      body
    })
  },

  getPointsHistory: queryParams => {
    return httpApi.getDataViaApi({
      url: api.rewards.pointsHistory,
      queryParams
    })
  },

  getScannedProductDetail: (queryParams) => {
    return httpApi.getDataViaApi({
      url: api.rewards.getScannedProductDetail,
      queryParams
    })
  },

  uploadInvoice: (body) => {
    return httpApi.uploadFileViaApi({
      url: api.rewards.uploadInvoice,
      body
    })
  },

  getGiftList: queryParams => {
    return httpApi.getDataViaApi({
      url: api.rewards.listGift,
      queryParams
    })
  },

  redeemGift: (body) => {
    return httpApi.postDataViaApi({
      url: api.rewards.redeemGift,
      body
    })
  },

  getRedeemedGiftDetails: (queryParams) => {
    return httpApi.getDataViaApi({
      url: api.rewards.getRedeemedGiftDetails,
      queryParams
    })
  },

  getRedeemedHistory: (queryParams) => {
    return httpApi.getDataViaApi({
      url: api.rewards.getRedeemedHistory,
      queryParams
    })
  }
}
